'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Parallax JS
 * Library for parallax effects
 *
 * @author Alexander Borunski
 */
var Parallax = function (w, d, $) {

    var _w = $(w);
    var _d = $(d);

    var Parallax = function () {
        function Parallax(root) {
            _classCallCheck(this, Parallax);
            this.init(root);
        }

        _createClass(Parallax, [{
            key: 'init',
            value: function init(root) {
                var _this = this;

                this.property = {
                    'id': parseInt(root.prop('id').substr(15)),
                    'howLongMoveX': parseInt(root.data('how_long_move_x')),
                    'howLongMoveY': parseInt(root.data('how_long_move_y')),
                    'zoom': parseInt(root.data('zoom')), //TODO: Breakpoint
                    'rotate': parseInt(root.data('rotate')), //TODO: Breakpoint
                    'offset': parseInt(root.data('offset')),
                    'howLongScroll': parseInt(root.data('how_long_scroll')),
                    'formatX': root.data('format_x'),
                    'formatY': root.data('format_y'),
                    'layer': parseInt(root.data('layer')),
                    'touchpadoff': Boolean(root.data('touchpadoff')),
                    'viewportContactsWithElement': root.data('viewport_contacts_with_element'),
                    'breakpoints': root.data('breakpoints'),
                    'isRootParallax': true
                };

                // root.imagesLoaded( () => {

                    if (typeof skrollr != 'undefined' && typeof skrollr.get() == 'undefined') {
                        skrollr.init({
                            smoothScrolling: true,
                            forceHeight: false,
                            mobileCheck: function mobileCheck() {
                                //hack - forces mobile version to be off
                                return false;
                            }
                        });
                    }
                    else {
                        skrollr.get().refresh();
                    }
                // });

                // console.log(this.property.breakpoints);

                // Sortiere die Breakpoints, da diese bei Fensterbreitenänderung
                // nach der Reihe aufgerufen werden und nur so logisch
                // die korrekten Attribut-Angaben in das Parallax-Element
                // geschrieben werden können.
                // Es wird immer nach "<=" gesucht, was bedeuten würde wenn die
                // Fensterbreite aktuell z.B. 500px breit wäre und der erste Breakpoint
                // 700px groß ist, dann würden die Parallax-Attribute geändert.
                // Im zweiten Schleifendurchlauf wird ein weiterer Breakpoint (1000px) mit der aktuellen
                // Fenstergröße vergichen und die aktuelle Fensterbreite wäre erneut kleiner als der
                // Breakpoint. Die Parallax-Attribute würden wieder aktuallisiert werden und bleiben in diesem
                // Zustand.
                if (this.property.breakpoints != "") {
                    this.property.breakpoints = function (array, key) {
                        return array.sort(function (a, b) {
                            var x = parseInt(a[key]);
                            var y = parseInt(b[key]);
                            return y < x ? -1 : y > x ? 1 : 0;
                        });
                    }(this.property.breakpoints, 'breakpoint');
                }

                //Replace Root with normal element, if the devie has a touchfunction
                if (this.property.touchpadoff == true && $("html").hasClass("zp-touch")) {
                    var tempElementWithoutParallax = root.children().children();
                    root = root.replaceWith(tempElementWithoutParallax);
                    this.property.isRootParallax = false;
                }

                //BREAKPOINTS
                //If this Element a Parallax-Element and exists breakpoints
                if (this.property.isRootParallax && root.attr('data-breakpoints') !== "") {

                    _w.on('resize', function () {


                        var windowWidth = _w.width();
                        var skrollrElement = root.children();

                        var windowIsOnABreakpoint = false;
                        for (var breakpointIndex = _this.property.breakpoints.length - 1; breakpointIndex >= 0; breakpointIndex--) {

                            //Window is on a breakpoint
                            if (windowWidth <= parseInt(_this.property.breakpoints[breakpointIndex]['breakpoint'])) {

                                windowIsOnABreakpoint = true;

                                _this.deleteParallaxAttributes(skrollrElement);

                                var hyphen;
                                if (_this.property.breakpoints[breakpointIndex]['viewport_contacts_with_element'] == "bottom-top") hyphen = '-';else hyphen = '';

                                //Add new Attributes
                                skrollrElement.attr('data-' + hyphen + _this.property.breakpoints[breakpointIndex]['offset'] + "-" + _this.property.breakpoints[breakpointIndex]['viewport_contacts_with_element'], 'transform: translate(0' + _this.property.breakpoints[breakpointIndex]['format_x'] + ',0' + _this.property.breakpoints[breakpointIndex]['format_y'] + ')');
                                skrollrElement.attr('data--' + (parseInt(_this.property.breakpoints[breakpointIndex]['how_long_scroll']) + parseInt(_this.property.breakpoints[breakpointIndex]['offset'])) + "-" + _this.property.breakpoints[breakpointIndex]['viewport_contacts_with_element'], 'transform: translate(' + _this.property.breakpoints[breakpointIndex]['how_long_move_x'] + _this.property.breakpoints[breakpointIndex]['format_x'] + ',' + _this.property.breakpoints[breakpointIndex]['how_long_move_y'] + _this.property.breakpoints[breakpointIndex]['format_y'] + ')');

                                // root.imagesLoaded(function () {
                                    skrollr.get().refresh();
                                // });
                                break;
                            }
                        }

                        //Standardverhalten
                        if (windowIsOnABreakpoint == false) {

                            _this.deleteParallaxAttributes(skrollrElement);

                            var hyphen;
                            if (_this.property.viewportContactsWithElement == "bottom-top") hyphen = '-';else hyphen = '';

                            //Add new Attributes
                            skrollrElement.attr('data-' + hyphen + _this.property.offset + "-" + _this.property.viewportContactsWithElement, 'transform: translate(0' + _this.property.formatX + ',0' + _this.property.formatY + ')');
                            skrollrElement.attr('data--' + (_this.property.howLongScroll + _this.property.offset) + "-" + _this.property.viewportContactsWithElement, 'transform: translate(' + _this.property.howLongMoveX + _this.property.formatX + ',' + _this.property.howLongMoveY + _this.property.formatY + ')');

                            // root.imagesLoaded(function () {
                                skrollr.get().refresh();
                            // });
                        }
                    });
                }
            }
        }, {
            key: 'deleteParallaxAttributes',
            value: function deleteParallaxAttributes(skrollrElement) {

                var removeParallaxAttributes = new Array();

                skrollrElement.each(function () {
                    $.each(this.attributes, function () {
                        if (this.specified) {
                            if (this.name.match(/\bdata-(\d+)\b-/) || this.name.match(/\bdata--(\d+)\b-/)) {
                                removeParallaxAttributes.push(this.name);
                            }
                        }
                    });
                });

                for (var i = 0; i < removeParallaxAttributes.length; i++) {
                    skrollrElement.removeAttr(removeParallaxAttributes[i]);
                }
            }
        }]);

        return Parallax;
    }();

    return Parallax;
}(window, document, jQuery);